import { createContext, useCallback, useEffect, useRef } from "react";
import Select from "react-select";
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Typography,
  Grid,
  Stack,
  Box,
  IconButton,
  InputLabel,
  FormControl,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useContext } from "react";
import { DocumentContext } from "./Logistic";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ClearIcon from "@mui/icons-material/Clear";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { useState } from "react";
import AgGridTable from "../utilities/AgGridTable";
import customStyles from "app/shared-components/SelectCustomStyle";
import CustomDatePicker from "../utilities/CustomDatePicker";
import DocumentUpload from "./DocumentUpload";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import moment from "moment";

const containerOptions = [
  { value: "bq1091", label: "BQ1091" },
  { value: "bq1092", label: "BQ1092" },
  { value: "bq1093", label: "BQ1093" },
  { value: "bq1094", label: "BQ1094" },
  { value: "bq1095", label: "BQ1095" },
];
const orderOptions = [
  { value: "order1", label: "Order_1768" },
  { value: "order2", label: "Order_2544" },
  { value: "order3", label: "Order_6578" },
  { value: "order4", label: "Order_8643" },
  { value: "order5", label: "Order_3948" },
];
const intialValue = [
  {
    srNo: 1,
    refNo: 361057901,
    country: "KSA",
    date: "2023-09-23",
    containerNo: "BQ1093",
    plannedContainerType: "20' Normal",
  },
  {
    srNo: 2,
    refNo: 361057902,
    country: "KSA",
    date: "2023-09-24",
    containerNo: "BQ1094",
    plannedContainerType: "20' Normal",
  },
];

const DocumentUploadContext = createContext();

const Document = () => {
  const containersUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.containers}`;
  const containerAttachmentUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getContainerAttachment}`;
  const downloadAttachmentUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.downloadAttachment}`;

  const gridRef = useRef();
  const [documentDialog, setDocumentDialog, openUploadDocDialog, selectedLogisticRows, containerId] = useContext(DocumentContext);
  const [containerNo, setContainerNo] = useState(selectedLogisticRows[0]?.id || containerId);
  const [containerOptions, setContainerOptions] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [filterData , setFilterData] = useState([]);
  const [docUploadDialog, setDocUploadDialog] = useState(false);
  const [createdAt , setCreatedAt] = useState(null);
  const [selectedRow ,setSelectedRow] = useState([]);

  const [columnCreateDefs, setColumnCreateDefs] = useState([
    { field: "folderName", enableRowGroup: true, minWidth:200 },
    { field: "attachmentName", enableRowGroup: true, minWidth:200 },
    { field: "comments", enableRowGroup: true, minWidth:200 },
    { field: "createdAt", enableRowGroup: true, minWidth:200 },
    {
      field: "downloadDocument",
      enableRowGroup: true,
      cellRenderer: dowloadIcon,
    },
  ]);

   const fileDownload = async (data) => {
      const model={
        containerPlanId: data.containerPlan.id,
        folderName: data.folderName,
        fileName: data.attachmentName
    }
      const download = await OAuthService.getDownload(downloadAttachmentUrl,model);
      const blob = download?.data;
      if (blob) {
          const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/octet-stream' }));
          const link = document.createElement('a');
          link.href = url;
          link.download = model.fileName;
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
      }
  }

  function dowloadIcon(params) {
    return (
      <div className="flex justify-center">
        <button onClick={() => fileDownload(params.data)}>
          <FileDownloadIcon fontSize={'small'} />
        </button>
      </div>
    );
  }

  const autoSizeAll = useCallback(
    (value) => {
      const allColumnIds = [];
      gridRef.current.columnApi.getColumns().forEach((column) => {
        allColumnIds.push(column?.getId());
      });
      gridRef.current.columnApi.autoSizeColumns(allColumnIds, value);
    },
    [rowData]
  );

  const onGridReady = useCallback((params) => {
    var columnToolPanel = gridRef.current.api.getToolPanelInstance("columns");
    columnToolPanel.expandColumnGroups();
    autoSizeAll(false);
  }, []);

  const onSelectionChanged = (params) => {
    setSelectedRow(params.api.getSelectedRows());
  };

  const handleContainerNoChange = (data) => {
    setContainerNo(data.value);
  };
  const handleOrderChange = (data) => {
    setOrderNo(data.value);
  };
  const handleDateChange = (value) =>{
    const date =  moment(value).format('DD-MM-YYYY');
    const filterByDate = rowData.filter((data)=> data.createdAt === date);
    setCreatedAt(value);
    setFilterData(filterByDate);
  }

  const getAttachment = async () => {
    const attachments = await OAuthService.getEditData(
      containerAttachmentUrl,
      containerNo
    );
    attachments.data.map((attachment)=>{  attachment.createdAt = moment(attachment.createdAt).format('DD-MM-YYYY')});
    setRowData(attachments.data);
  };

  const getContainerList = async () => {
    const value = { };
    const containers = await OAuthService.addData(containersUrl, value);
    const containerPlans = containers.data.content;
    const conatinersData = containerPlans.map((container) => {
      return {
        value: container.id,
        label: container.containerNo,
      };
    });
    setContainerOptions(conatinersData);
    // setConatiners(containerPlans);
  };

  useEffect(() => {
    getContainerList();
  }, []);
  useEffect(() => {
    getAttachment();
  }, [containerNo]);

    useEffect(() => {
      if(documentDialog){
        setDocUploadDialog(openUploadDocDialog);
      }
  }, [openUploadDocDialog]);
  
  return (
    <>
      <Dialog
        open={documentDialog}
        onClose={() => setDocumentDialog(false)}
        fullWidth={true}
        maxWidth={"md"}
      >
        <DialogTitle>
          <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
            <span>Document Details</span>
            <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
              <Button onClick={() => setDocumentDialog(false)}>
                <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
              </Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            <>
              <Grid container spacing={2} className="mb-16">
                <Grid item xs={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <Stack>
                        <label>Select Container No</label>
                        <Select
                          name="containerNo"
                          value={
                            containerNo &&
                            containerOptions &&
                            containerOptions.filter(
                              (obj) => containerNo === obj.value
                            )
                          }
                          onChange={handleContainerNoChange}
                          options={containerOptions}
                          styles={customStyles()}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={4}>
                      <Stack>
                        <label>Date</label>
                        <CustomDatePicker
                          className="w-[170px]"
                          format={"dd-mm-yyyy"}
                          name={"date"}
                          value={createdAt}
                          handleChange={(e) => handleDateChange(e)}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={3} className="flex justify-end mt-24">
                  <Button
                    variant="contained"
                    color="warning"
                    onClick={() => setDocUploadDialog(true)}
                  >
                    <Typography color="black">Upload</Typography>
                  </Button>
                </Grid>
              </Grid>
              <div className="h-[400px]">
                <AgGridTable
                  rowData={createdAt ? filterData : rowData}
                  gridRef={gridRef}
                  columnDefs={columnCreateDefs}
                  editable={false}
                  hideCheckbox={true}
                  onSelectionChanged={onSelectionChanged}
                  rowSelection={'single'}
                  skipHeader={false}
                  onGridReady={onGridReady}
                />
              </div>
            </>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <DocumentUploadContext.Provider
        value={[
          docUploadDialog,
          setDocUploadDialog,
          containerOptions,
          containerNo,
          handleContainerNoChange,
          openUploadDocDialog
        ]}
      >
        <DocumentUpload />
      </DocumentUploadContext.Provider>
    </>
  );
};

export default Document;
export { DocumentUploadContext };
